module.exports = __webpack_public_path__ + "img/people_img_4_2.2ecd554e.png";